// Global Instructions Rule Applied!
//
// Select lists + fund context for the Investors-tab commitment editor
// (view__fund_commitment_editor_options). Fetched once per fund on mount —
// the table needs `fund.fund_groups__name` to gate "New Commitment" on a
// consolidated-fund member before the modal ever opens. `reload` refreshes
// the investor list after a save created a new investor entity.

import { useCallback, useEffect, useState } from 'react'
import { store } from '../../../state_manager/store.ts'
import { getAccessToken } from '../../../core/auth/authService'
import { showErrorToast } from '../../../core/utils/errorToast.tsx'
import { fetchFundCommitmentEditorOptions } from '../services/fundsService.ts'
import type { FundCommitmentEditorOptions } from '../../../state_manager/data_models/fund_commitment_editor.ts'

export function useFundCommitmentEditorOptions(fundId: string | null) {
  const [options, setOptions] = useState<FundCommitmentEditorOptions | null>(null)
  const [version, setVersion] = useState(0)

  useEffect(() => {
    if (!fundId) return
    let cancelled = false
    ;(async () => {
      const res = await fetchFundCommitmentEditorOptions(fundId, getAccessToken(store.getState().auth))
      if (cancelled) return
      if (res.error || !res.data) showErrorToast(res.error || 'Failed to load commitment options')
      else setOptions(res.data)
    })()
    return () => {
      cancelled = true
    }
  }, [fundId, version])

  const reload = useCallback(() => setVersion((v) => v + 1), [])

  return { options, reload }
}
